<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>

<script>
export default {
  head() {
    return {
      title: "About",
      meta: [{ name: "description", content: "About the ICJIA Intranet." }],
    };
  },
};
</script>
